{
  "name": "@vutolabs/analytics",
  "version": "0.0.0-alpha.4",
  "description": "Vuto Analytics - instant, Stripe-native analytics for SaaS apps built with Next.js or React.",
  "keywords": [
    "analytics",
    "saas",
    "stripe",
    "nextjs",
    "react",
    "tracking",
    "mrr",
    "conversion"
  ],
  "license": "MPL-2.0",
  "author": "Kelvin Dupont",
  "repository": {
    "type": "git",
    "url": "https://github.com/vutolabs/analytics"
  },
  "homepage": "https://vuto.dev",
  "bugs": {
    "url": "https://github.com/vutolabs/analytics/issues"
  },
  "main": "./dist/index.js",
  "module": "./dist/index.mjs",
  "types": "./dist/index.d.ts",
  "files": [
    "dist"
  ],
  "exports": {
    "./package.json": "./package.json",
    ".": {
      "import": "./dist/index.mjs",
      "require": "./dist/index.js",
      "types": "./dist/index.d.ts"
    },
    "./next": {
      "import": "./dist/nextjs/index.mjs",
      "require": "./dist/nextjs/index.js",
      "types": "./dist/nextjs/index.d.ts"
    },
    "./react": {
      "import": "./dist/react/index.mjs",
      "require": "./dist/react/index.js",
      "types": "./dist/react/index.d.ts"
    }
  },
  "typesVersions": {
    "*": {
      "*": [
        "dist/index.d.ts"
      ],
      "next": [
        "dist/nextjs/index.d.ts"
      ],
      "react": [
        "dist/react/index.d.ts"
      ]
    }
  },
  "scripts": {
    "build": "tsup",
    "dev": "tsup --watch",
    "type-check": "tsc --noEmit"
  },
  "devDependencies": {
    "@swc/core": "^1.9.2",
    "@types/node": "^22.9.0",
    "@types/react": "^18.3.20",
    "@types/react-dom": "^19.1.2",
    "next": "^15.3.0",
    "tsup": "8.3.5",
    "typescript": "^5.1.6"
  },
  "peerDependencies": {
    "next": ">=13",
    "react": "^18 || ^19"
  },
  "peerDependenciesMeta": {
    "next": {
      "optional": false
    },
    "react": {
      "optional": false
    }
  }
}
